import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonFieldConfig } from '../../../model/form.model';
import { BUTTON_NAMES, ButtonNames } from '../../../model/common.model';
import { CamelCasePipe } from "../../../utils/camel-case.pipe";

@Component({
  selector: 'app-button-field',
  standalone: true,
  imports: [CommonModule, CamelCasePipe],
  templateUrl: './button-field.component.html',
  styleUrls: ['./button-field.component.scss']
})
export class ButtonFieldComponent implements OnInit,OnChanges {
  @Input() buttonConfig!: ButtonFieldConfig;
  @Input() isLoading = false;
  isDisabled = false;
  changeRef = inject(ChangeDetectorRef)
  readonly ButtonDisplayValue: typeof BUTTON_NAMES = BUTTON_NAMES;
  @Output() buttonClicked = new EventEmitter<{ name: ButtonNames }>();

  ngOnInit(){
    this.buttonConfig.detectChanges = ()=>{
       this.isDisabled = !!this.buttonConfig.isDisabled 
    }
  }
  ngOnChanges(_changes: SimpleChanges) {
    this.isDisabled = !!this.buttonConfig.isDisabled 
  }
  onButtonClicked(name: ButtonNames) {
    if (this.isLoading || this.isDisabled) {
      return;
    }
    this.buttonClicked.emit({ name });
    if(this.buttonConfig['actionCallback']){
      this.buttonConfig['actionCallback']({name})
    }
  }
}
